// Base URL from environment variable. Falls back to the HTTPS demo domain.
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://bqdemo.wemotive.in';

export const API_ENDPOINTS = {
  // Auth
  SEND_OTP: '/api/v1/auth/send-otp',
  VERIFY_OTP: '/api/v1/auth/verify-otp',
  REFRESH_TOKEN: '/api/v1/auth/refresh-token',
  LOGOUT: '/api/v1/auth/logout',

  // Users
  GET_SETUP_STATUS: '/api/v1/users/setup-status',
  GET_USER_PROFILE: '/api/v1/users/me/profile', // GET + PATCH (display_name)
  SET_PIN: '/api/v1/users/set-pin',
  PROFILE_IMAGE_UPLOAD_URL: '/api/v1/users/profile-image/upload-url',
  UPDATE_PROFILE_IMAGE: '/api/v1/users/profile-image',

  // Categories
  GET_CATEGORIES: '/api/v1/categories',

  // Business
  CREATE_BUSINESS: '/api/v1/businesses',
  GET_MY_BUSINESS: '/api/v1/businesses/me',
  UPDATE_BUSINESS: '/api/v1/businesses/me',

  // Team
  GET_MY_ROLE: '/api/v1/team/me/role',
  GET_TEAM_MEMBERS: '/api/v1/team',
  GET_TEAM_PROVIDERS: '/api/v1/team/providers',

  // Queues
  GET_QUEUES: '/api/v1/queues',
  GET_QUEUE_SUMMARY: '/api/v1/queues/summary',
  GET_TOKEN_USAGE: '/api/v1/queues/token-usage',
  GET_DASHBOARD: '/api/v1/queues/dashboard',

  // Tokens (queue-scoped list/walk-in/slot use the /queues base; single-token
  // actions use the /tokens base)
  TOKENS: '/api/v1/tokens', // + /:id, /:id/status, /:id/provider, /:id/complete

  // Holidays
  HOLIDAYS: '/api/v1/holidays', // + /check-tokens, /:id

  // Consultations (medical) — token-scoped consultation uses the /tokens base
  CONSULTATION_HISTORY: '/api/v1/consultations/history', // ?country_code=&phone=

  // Subscription
  GET_SUBSCRIPTION: '/api/v1/subscriptions/current',
  GET_TRIAL_STATUS: '/api/v1/subscriptions/trial-status',
  GET_ACTIVE_SUBSCRIPTIONS: '/api/v1/subscriptions/active',
  GET_PLANS: '/api/v1/subscriptions/plans',
  CREATE_SUBSCRIPTION: '/api/v1/subscriptions',
  VALIDATE_SUBSCRIPTION: '/api/v1/subscriptions/validate',
  VERIFY_PAYMENT: '/api/v1/subscriptions/verify-payment',
  UPGRADE_SUBSCRIPTION: '/api/v1/subscriptions/upgrade',
  CANCEL_SUBSCRIPTION: '/api/v1/subscriptions', // append /:id/cancel
  GET_PRICING_CONFIG: '/api/v1/subscriptions/pricing',
  GET_PAYMENT_HISTORY: '/api/v1/subscriptions/history',

  // Invoice
  GET_INVOICE: '/api/v1/invoices', // append /:subscription_id
  DOWNLOAD_INVOICE: '/api/v1/invoices', // append /:subscription_id/download
} as const;
